import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyStart: {
        id: 'policycommon.component.policy-common-details.Policy Start',
        defaultMessage: 'Effective Date'
    },
    PolicyExpiration: {
        id: 'policycommon.component.policy-common-details.Policy Expiration',
        defaultMessage: 'Expiration Date'
    },
    PolicyType: {
        id: 'policycommon.component.policy-common-details.Policy Type',
        defaultMessage: 'Policy Type'
    },
    TotalPremium: {
        id: 'policycommon.component.policy-common-details.Total Annual Premium',
        defaultMessage: 'Total Annual Premium'
    },
    TaxesAndFees: {
        id: 'policycommon.component.policy-common-details.Taxes and Fees',
        defaultMessage: 'Taxes and Fees'
    },
    TotalCost: {
        id: 'policycommon.component.policy-common-details.Total Annual Cost',
        defaultMessage: 'Total Annual Cost'
    },
    commonDetailsSection: {
        id: 'policycommon.component.policy-common-details.Details',
        defaultMessage: 'Details for {polNumber}'
    },
    premium: {
        id: 'policycommon.component.policy-common-details.Premium',
        defaultMessage: 'Premium'
    },
    policyStatus: {
        id: 'policycommon.component.policy-common-details.PolicyStatus',
        defaultMessage: 'Status'
    },
    active: {
        id: 'policycommon.component.policy-common-details.Active',
        defaultMessage: 'Active'
    },
    scheduled: {
        id: 'policycommon.component.policy-common-details.Scheduled',
        defaultMessage: 'Scheduled'
    },
    inActive: {
        id: 'policycommon.component.policy-common-details.Inactive',
        defaultMessage: 'Inactive'
    },
    payments: {
        id: 'policycommon.component.policy-common-details.Payments',
        defaultMessage: 'Payments'
    },
    nextPaymentDueBy: {
        id: 'policycommon.component.policy-common-details.Next Payment Due By',
        defaultMessage: 'Next Payment Date'
    },
    nextPaymentAmount: {
        id: 'policycommon.component.policy-common-details.Next Payment Amount',
        defaultMessage: 'Next Payment Amount'
    },
    lastPaymentDate: {
        id: 'policycommon.component.policy-common-details.Last Payment Date',
        defaultMessage: 'Last Payment Date'
    },
    lastPaymentAmount: {
        id: 'policycommon.component.policy-common-details.Last Payment Amount',
        defaultMessage: 'Last Payment Amount'
    },
    EmailMeButtonMsg: {
        id: 'policycommon.component.policy-common-details.Email Me My Digital Pink Slip',
        defaultMessage: 'Email Me My Digital Pink Slip'
    },
    EmailMeTooltipMsg: {
        id: 'policycommon.component.policy-common-details.Email Me Tooltip Message',
        defaultMessage: 'This button will trigger email delivery of your electronic Proof of Automobile Insurance for download to your preferred mobile digital wallet.'
    },
    errorMsg: {
        id: 'policycommon.component.policy-common-details.Error',
        defaultMessage: 'Error'
    },
    emailSentFailed: {
        id: 'policycommon.component.policy-common-details.Unable to send email, please try after some time.',
        defaultMessage: 'Unable to send email, please try after some time.'
    },
    displayBillingInfoMessageDescription: {
        id: 'policycommon.component.policy-common-details.Information for no billing data.',
        defaultMessage: 'Your policy is not yet in force. Please see the My Billing tab or your most recent policy document for next payment due.'
    },
    billingStatus: {
        id: 'policycommon.component.policy-common-details.Billing Status',
        defaultMessage: 'Billing Status'
    },
    paymentMethod: {
        id: 'policycommon.component.policy-common-details.Payment Method',
        defaultMessage: 'Payment Method'
    },
    termMesg: {
        id: 'policycommon.component.policy-common-details.Term',
        defaultMessage: 'Term'
    }
});
